import { jsx } from 'react/jsx-runtime';
import { clsx } from '@flex-design-system/ve-presets';
import { Primitive } from '@radix-ui/react-primitive';
import { forwardRef } from 'react';
import { segmentedControlItemSlot } from './itemSlot.vanilla.mjs';

const SegmentedControlItemSlot = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = clsx(segmentedControlItemSlot, classNameFromProps);
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "segmented-control",
      "data-part": "item-slot",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});
SegmentedControlItemSlot.displayName = "SegmentedControl.ItemSlot";

export { SegmentedControlItemSlot };
//# sourceMappingURL=ItemSlot.mjs.map
